export { default, getStaticProps } from 'src/pages/Generic/pages/CodeOfConduct'
